import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectHopTimusEnabled } from '@/containers/Login/AuthSelectors'
import { useSnackbarNotification } from '@/shared/tools/notifications/useSnackbarNotification'
import { hopTimusActions } from './hopTimusSagas'
import { selectHopTimusDockAvailable, selectHopTimusIsLoading } from './hopTimusSelectors'
import useHopTimusShortcut from './useHopTimusShortcut'

const useHopTimusButton = () => {
  const dispatch = useDispatch()
  const hopTimusEnabled = useSelector(selectHopTimusEnabled)
  const dockAvailable = useSelector(selectHopTimusDockAvailable)
  const isLoading = useSelector(selectHopTimusIsLoading)
  const { t } = useTranslation()
  const showNotification = useSnackbarNotification()
  const isEnabled = hopTimusEnabled && !dockAvailable

  const activate = useCallback(() => {
    dispatch({
      type: hopTimusActions.ACTIVATE,
      pageUrl: window.location.href,
      unavailableMessage: t('common:hop_timus_unavailable'),
      showNotification,
    })
  }, [dispatch, showNotification, t])

  const openWidget = useCallback(() => {
    if (window.Pulse) {
      window.Pulse.toggle()
      return
    }

    activate()
  }, [activate])

  const openFromShortcut = useCallback(() => {
    if (isLoading) return
    if (window.Pulse) {
      window.Pulse.open()
      return
    }

    activate()
  }, [activate, isLoading])

  useHopTimusShortcut(isEnabled, openFromShortcut)

  return { isEnabled, isLoading, openWidget }
}

export default useHopTimusButton
